/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Editing_FcInputs */

const en_fc_cmp_editing_fc = /** @type {(inputs: Fc_Cmp_Editing_FcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three-point editing, all trim modes, J-K-L`)
};

/**
* | output |
* | --- |
* | "Three-point editing, all trim modes, J-K-L" |
*
* @param {Fc_Cmp_Editing_FcInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_editing_fc = /** @type {((inputs?: Fc_Cmp_Editing_FcInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Editing_FcInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_editing_fc(inputs)
});
export { fc_cmp_editing_fc as "fc.cmp.editing.fc" }